import { toast } from "react-toastify";
import { base_url, endpoints } from "../Api/configs";
import apiClient, { parseResponseBody } from "./apiClient";

export const disputesGetAll = async (accessToken: string) => {
  const bodyParams = {
    accessToken: accessToken,
  };

  return apiClient(endpoints.disputes.disputesGetAll, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const disputesSend = async (
  accessToken: string,
  disputeID: string,
  proofUrl: string,
  timestamp: string,
  reason: string = ""
) => {
  const bodyParams = {
    accessToken: accessToken,
    disputeID,
    proofUrl,
    timestamp,
    reason,
  };

  return apiClient(endpoints.disputes.disputesSend, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export async function adminDisputesGetAll(
  accessToken,
  lastEvaluatedKey = null,
  limit = 10
) {
  const url = `${base_url}${endpoints.disputes.adminDisputeGetAll}`;
  const bodyParams = {
    accessToken: accessToken,
    lastEvaluatedKey,
    limit,
  };

  try {
    const res = await fetch(url, {
      mode: "cors",
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ body: bodyParams }),
    });

    let response = await res.json();
    response = parseResponseBody(response);

    if (res.status === 200 && response.statusCode === 200) {
      return {
        disputes: response.body.disputes,
        lastEvaluatedKey: response.body.lastEvaluatedKey
          ? response.body.lastEvaluatedKey
          : "",
        count: response.body.count ? response.body.count : 50,
      };
    } else {
      toast.error(response.error);
    }
  } catch (error) {
    toast.error(error.message);
  }
}

export const adminDisputeGetSpecific = async (
  accessToken: string,
  eventID: string
) => {
  const bodyParams = {
    accessToken: accessToken,
    eventID: eventID,
  };

  return apiClient(endpoints.disputes.adminDisputeGetSpecific, {
    method: "POST",
    body: JSON.stringify({
      body: bodyParams,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const adminWinner = async (
  accessToken: string,
  eventID: string,
  winner: string,
  loser: string,
  DisputeID: string,
  DisputeTimeStamp: string
) => {
  const bodyParams = {
    accessToken: accessToken,
    eventID: eventID,
    winner,
    loser,
    DisputeID,
    DisputeTimeStamp,
  };

  return apiClient(endpoints.disputes.adminWinner, {
    method: "POST",
    body: JSON.stringify(bodyParams),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
export const adminPublicVoteResult = async (
  accessToken: string,
  eventID: string
) => {
  const bodyParams = {
    accessToken: accessToken,
    eventID: eventID,
  };

  return apiClient(endpoints.disputes.adminPublicVoteResult, {
    method: "POST",
    body: JSON.stringify(bodyParams),
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const generateDispute = async (accessToken: string, eventID: string) => {
  const bodyParams = {
    accessToken: accessToken,
    eventID: eventID,
  };

  return apiClient(endpoints.disputes.generateDispute, {
    method: "POST",
    body: JSON.stringify(bodyParams),
    headers: {
      "Content-Type": "application/json",
    },
  });
};
